import { configureStore } from "@reduxjs/toolkit";
import { useDispatch, useSelector, TypedUseSelectorHook } from "react-redux";
import errorBoundarySlice from "src/store/errorBoundarySlice";
import toastsSlice from "src/store/toastsSlice";
import userSlice from "src/store/userSlice";
import sideMenuSlice from "src/store/sideMenuSlice";
import createAssessmentSlice from "src/store/createAssessmentSlice";
import headerSlice from "src/store/headerSlice";
import stepsToRecordVideoSlice from "src/store/stepsToRecordVideoSlice";
import recordVideoSlice from "src/store/recordVideoSlice";
import createNewAssessmentShellSlice from "src/store/createNewAssessmentShellSlice";
import assessmentLibrarySlice from "src/store/assessmentLibrarySlice";
import assessmentDetailSlice from "src/store/assessmentDetailSlice";
import rumSlice from "src/store/rumSlice";
import regionDisplaySlice from "src/store/regionDisplaySlice";
import videoToGraphSyncSlice from "src/store/videoToGraphSyncSlice";
import globalLayoutSlice from "src/store/globalLayoutSlice";
import jobRotationAssessmentLibrarySlice from "src/store/jobRotationAssessmentLibrarySlice";
import createJobRotationAssessmentSlice from "src/store/createJobRotationAssessmentSlice";
import dataSlice from "src/store/dataSlice";
import createLmeAssessmentSlice from "src/store/createLmeAssessmentSlice";
export const reducers = {
  errorBoundary: errorBoundarySlice,
  toasts: toastsSlice,
  user: userSlice,
  sideMenu: sideMenuSlice,
  createAssessment: createAssessmentSlice,
  header: headerSlice,
  stepsToRecordVideo: stepsToRecordVideoSlice,
  recordVideoSlice: recordVideoSlice,
  createNewAssessmentShell: createNewAssessmentShellSlice,
  assessmentLibrary: assessmentLibrarySlice,
  assessmentDetail: assessmentDetailSlice,
  rum: rumSlice,
  regionDisplay: regionDisplaySlice,
  videoToGraphSyncSlice,
  globalLayout: globalLayoutSlice,
  jobRotationAssessmentLibrary: jobRotationAssessmentLibrarySlice,
  createJobRotationAssessment: createJobRotationAssessmentSlice,
  data: dataSlice,
  createLmeAssessment: createLmeAssessmentSlice,
};

const store = configureStore({
  reducer: reducers,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false, // to allow non serializable objects to be stored in redux (eg: Map, Set, classes, react components etc.)
    }),
});

export type RootState = ReturnType<typeof store.getState>;

export type AppDispatch = typeof store.dispatch;
export const useAppDispatch = () => useDispatch<AppDispatch>();
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;

export default store;
